import type { ItemType, QuizAnswerType, VariantTypeV2 } from "types"
import type { QuizResultStep } from "../hooks/useQuizResults"
import { quizSlug } from "../quiz.constants"

export const getItemsTotal = (
  items: QuizResultStep[],
  membership: ItemType | undefined,
  priceType: "members" | "typical",
  addMembership: boolean
): number => {
  const total = items.reduce((t, i) => {
    const price = (i.item.variant as VariantTypeV2).pricing[priceType]
    return t + price
  }, 0)

  if (addMembership && membership) {
    return (
      total + membership.quantity * Number(membership.membership?.price ?? 0)
    )
  }

  return total
}

export const getQuizPath = (uri = ""): string => {
  const quizUrl = `/quiz/${quizSlug}`

  if (uri === "") return quizUrl

  return quizUrl.concat(`/`, uri)
}

export const filterAnswers = (
  currentQuestion: string,
  currentAnswers: QuizAnswerType[],
  skinType?: string
): QuizAnswerType[] => {
  if (currentQuestion !== "skin-concern") return currentAnswers

  let newAns: QuizAnswerType[]

  switch (skinType) {
    case "BBP":
    case "D": {
      newAns = currentAnswers.filter((ans) =>
        ["RS", "FSA", "DE", "HUE", "MS"].includes(ans.key)
      )
      break
    }
    case "RS": {
      newAns = currentAnswers.filter((ans) =>
        ["BBP", "DUL", "FSA", "DE", "HUE", "MS"].includes(ans.key)
      )
      break
    }
    case "FSA": {
      newAns = currentAnswers.filter((ans) =>
        ["BBP", "DUL", "RS", "DE", "HUE", "MS"].includes(ans.key)
      )
      break
    }
    case "DE": {
      newAns = currentAnswers.filter((ans) =>
        ["DUL", "RS", "FSA", "HUE", "MS"].includes(ans.key)
      )
      break
    }
    case "HUE": {
      newAns = currentAnswers.filter((ans) =>
        ["BBP", "DUL", "RS", "FSA", "DE", "MS"].includes(ans.key)
      )
      break
    }
    case "MS": {
      newAns = currentAnswers.filter((ans) =>
        ["BBP", "RS", "FSA", "DE", "HUE"].includes(ans.key)
      )
      break
    }
    case "NS":
    case "CS": {
      newAns = currentAnswers.filter((ans) =>
        ["DUL", "RS", "FSA", "DE", "HUE", "MS"].includes(ans.key)
      )
      break
    }
    default:
      newAns = currentAnswers
  }

  return newAns
}
